module.exports = __webpack_public_path__ + "static/media/Ziraat.7e12efac.svg";